var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("article", [
    _c("div", { staticClass: "cont-tit" }, [
      _c("h6", [_vm._v(_vm._s(_vm.title || _vm.$t(_vm.titleI18n)))])
    ]),
    _c(
      "dl",
      { class: ["dlist", "dlist-item--" + _vm.cssType] },
      [_vm._t("content")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }